module.exports = __webpack_public_path__ + "media/fonts/sovremennic/SovremennicCondensed-Medium-228c42983571d6b94a43ea1214e10831.woff2";